import script from "./VorauswahlFuehrerschein.vue?vue&type=script&setup=true&lang=js"
export * from "./VorauswahlFuehrerschein.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__